import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { DeviceInfoData } from './DeviceInfo';

interface PropsObject {
    deviceData: DeviceInfoData[]
}

const DeviceInfoCard: React.FC<PropsObject> = (props) => {
    const { deviceData } = props;

    return (
        <Row className='d-row'>
            {deviceData?.map((res, i) => (
                <Col className='d-col' key={`${res?.title} ${i}`}>
                    <h6>{res?.title}</h6>
                    <p>{res?.value}</p>
                </Col>
            ))}
        </Row>
    );
};

export default DeviceInfoCard;